export const VERIFY_SPECIAL_ACCESS_REQUEST = 'VERIFY_SPECIAL_ACCESS_REQUEST';
export const VERIFY_SPECIAL_ACCESS_SUCCESS = 'VERIFY_SPECIAL_ACCESS_SUCCESS';
export const VERIFY_SPECIAL_ACCESS_FAILURE = 'VERIFY_SPECIAL_ACCESS_FAILURE';

export const EDIT_EMAIL = 'EDIT_EMAIL';

export const RESET = 'RESET';
